import { render, staticRenderFns } from "./AccidentsCountDetail.vue?vue&type=template&id=0b1f26a0&"
import script from "./AccidentsCountDetail.vue?vue&type=script&lang=js&"
export * from "./AccidentsCountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports